'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$scope', '$uibModalInstance', 'opts',
    function ($scope, $modalInstance, opts) {

        $scope.opts = angular.copy(opts);

        $scope.ok = function () {
            $modalInstance.close();
        };

        $scope.cancel = function () {
            $modalInstance.dismiss();
        };
    }];
